import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

@Component({
  selector: 'app-analytics',
  standalone: true,
  imports: [CommonModule, FormsModule,

    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss','../../../../../styles/admin/style.scss','../../../../../styles/admin/app.scss']
})
export class AnalyticsComponent implements OnInit {
  selectedTimeframe: string = 'week'; // Default selection for radio buttons
  customSelected: boolean = false; // Default state for custom slide toggle
  constructor() { }

  ngOnInit(): void {
  }

}
